import React from 'react'
import EventHeader from './EventHeader'
import EventDetails from './EventDetails'
import SideCard from './SideCard'

function MainContent() {
  return (
    <div>
      <EventHeader />
      <div className='flex flex-col lg:flex-row gap-8 pt-[50px] pb-[120px] px-[90px]'>
         <EventDetails />
         <SideCard />
      </div>
    </div>
  )
}

export default MainContent